import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  //------View without data -------
  rootNoData: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F7F8FC',
    color: '#9A9AAF',
    height: '224px',
    boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.03)',
    fontWeight: 400,
    fontSize: '14px',
    position: 'relative',
  },
  flex: {
    display: 'flex',
  },
  noDataText: {
    fontFamily: "'Inter'",
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    color: '#9A9AAF',
    marginTop: '5px',
    marginBottom: '20px',
  },
  buttonPrimaryContent: {
    color: theme.palette.primary.primary800,
  },
  updateButton: {
    marginTop: '15px',
  },

  //------View with Data -------
  actionsTopButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '9px',
    gap: '12px',
    alignItems: 'center',
  },
  button: {
    margin: '5px',
    height: '32px',
  },
  content: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
  },
  buttonContent: {
    display: 'flex',
    gap: '5px',
    fontSize: '12px',
    alignItems: 'center',
  },
  scoreGraph: {
    borderRadius: '10px',
    background: theme.palette.background.white,
    boxShadow: '0px 6px 16px 0px rgba(21, 12, 115, 0.06)',
    overflow: 'hidden',
    flexShrink: 0,
  },
  scoreColumn: {
    borderRadius: '10px',
    fontSize: '26px',
    fontWeight: 600,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '150px',
  },
  scoreColumnBorder: {
    borderLeft: '1px solid ' + theme.palette.grey.grey300,
    paddingRight: '20px',
  },
  scoreLabel: {
    display: 'flex',
    fontWeight: 600,
    fontSize: '16px',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 20px',
    gap: '10px',
    color: theme.palette.black.dark,
  },
  gaugeStyle: {
    marginBottom: '5px !important',
    height: '90px',
    marginRight: '20px !important',
    marginLeft: '20px !important',
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  globalScoreText: {
    borderRadius: '5px',
    padding: '2px 16px',
    fontSize: '24px',
    fontWeight: '700',
    position: 'relative',
    marginBottom: '5px',
  },
  score5background: {
    background:
      'linear-gradient(180deg, #FFEBEB -9.6%, rgba(255, 235, 235, 0.00) 55.1%), #FFF',
    color: theme.palette.error.error600,
  },
  score4background: {
    background:
      'linear-gradient(180deg, #FFEBCC -9.6%, rgba(255, 247, 235, 0.00) 55.1%), #FFF',
    color: theme.palette.warning.warning600,
  },
  score3background: {
    background:
      'linear-gradient(180deg, #FFF7EB -9.6%, rgba(255, 247, 235, 0.00) 55.1%), #FFF',
    color: theme.palette.warning.warning500,
  },
  score2background: {
    background:
      'linear-gradient(180deg, rgba(96, 210, 115, 0.50) -9.6%, rgba(96, 210, 115, 0.00) 55.1%), #FFF',
    color: theme.palette.primary.primary400,
  },
  score1background: {
    background:
      'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(96, 210, 115, 0.10) 19.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    color: theme.palette.primary.primary600,
  },
  scoreUnknownBackground: {
    background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(83, 83, 98, 0.10) 19.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    color: theme.palette.grey.grey400,
  },
  scoreDetails: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '1fr 0.3fr',
    alignItems: 'center',
    maxWidth: '700px',
    borderRadius: '10px',
    background:
      'linear-gradient(90deg, rgb(71 233 255 / 9%) 0%, rgb(228 213 237 / 14%) 100%)',
    padding: '10px 20px 10px 20px',
    columnGap: '20px',
    '& > div:first-of-type': {
      borderRight: '1px solid ' + theme.palette.grey.grey300,
      paddingRight: '20px',
    },
  },
  scoreDetailsContent: {
    color: theme.palette.black.dark,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '6px',
    fontSize: '12px',
    fontWeight: '600',
    marginBottom: '6px',
  },
  dataDepthSection: {
    minWidth: '242px',
    '& > div': {
      backgroundColor: 'unset !important',
      boxShadow: 'unset !important',
    },
  },
  scoreDetailsSection: {
    color: theme.palette.grey.grey400,
    fontWeight: '600',
    lineHeight: '16px',
    fontSize: '12px',
    paddingBottom: '8px',
  },
  squareScore: {
    minWidth: '40px',
    height: '25px',
    borderRadius: '16px',
    color: '#FFF',
    padding: '2px 7px',
    textAlign: 'center',
    lineHeight: '1.7em',
  },
  openDetailsbutton: {
    width: '20px',
    height: '20px',
    border: '1px solid ' + theme.palette.grey.grey300,
    borderRadius: '16px',
    display: 'flex',
    padding: '2px',
    marginLeft: 'auto',
    backgroundColor: theme.palette.grey.grey100,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.grey.grey200,
    },
  },
  openGlobalDetailsbutton: {
    border: '1px solid ' + theme.palette.grey.grey300,
    borderRadius: '16px',
    display: 'flex',
    gap: '5px',
    padding: '2px',
    color: theme.palette.grey.grey500,
    fontSize: '12px',
    fontWeight: 600,
    backgroundColor: '#FFF',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.grey.grey100,
    },
  },
  dialogStop: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '32px',
  },
  dialogStopActions: {
    display: 'flex',
    gap: '16px',
  },
  dialogStopContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    alignSelf: 'stretch',
  },
  dialogStopIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '55px',
    height: '55px',
    borderRadius: '78px',
    backgroundColor: theme.palette.error.error100,
  },
  nationalScore: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    textAlign: 'center',
    marginBottom: '15px',
    color: theme.palette.black.dark,
    '& .score': {
      fontSize: '34px',
    },
    '& .max-score': {
      opacity: 0.4,
    },
    '& .no-score': {
      fontSize: '20px'
    }
  },
  scoreBadge: {
    width: '100px',
    height: '35px',
    borderRadius: '4px',
    color: '#FFF',
    padding: '2px 7px',
    textAlign: 'center',
    fontSize: '22px',
  },
  internationalScoreBadge: {
    width: '63px',
    height: '63px',
    borderRadius: '4px',
    color: '#FFF',
    padding: '2px 7px',
    textAlign: 'center',
    fontSize: '22px',
    paddingTop: '14px',
  },
  internationalScoreText: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '14px',
    marginLeft: '10px',
  },
  scoreDetailValueRisksWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    gap: '17px',
    marginBottom: '18px',
  },
  scoreDetailValueWrapper: {
    width: '174px',
    height: '129px',
    flexShrink: 0,
    borderRadius: '10px',
    padding: '16px',
    /* '&.score-A': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(43, 152, 62, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
    '&.score-B': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(84, 204, 84, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
    '&.score-C': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(255, 174, 51, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
    '&.score-D': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(204, 123, 0, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
    '&.score-E': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(255, 63, 64, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
    '&.score--': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(83, 83, 98, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    }, */
  },
  scoreDetailValueTitle: {
    color: theme.palette.black.dark,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    marginBottom: '12px',
  },
  scoreDetailValueSquare: {
    position: 'relative',
    fontSize: '36px',
    fontWeight: 700,
    lineHeight: '42px',
    fontStyle: 'normal',
    justifyContent: 'center',
    textAlign: 'center',
    '&.size-x-small': {
      fontSize: '20px',
    },
    '&.size-small': {
      fontSize: '24px',
    },
    '&.size-normal': {
      fontSize: '36px',
    },
  },
  scoreDetailValue: {
    position: 'absolute',
    top: '16%',
    width: '136px',
  },
  scoreDetailRiskWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  scoreDetailRiskTitle: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '18px',
    color: theme.palette.black.dark,
  },
  scoreDetailRisk: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '140%',
  },
}));

export default useStyles;